import NextImage, { ImageProps } from "next/legacy/image";
import { createLoaderWithTransform, Transform } from "components/Image/createLoaderWithTransform";

interface Props extends ImageProps {
  transform?: Transform;
}

const LegacyImage = ({ className = "", transform = undefined, style, alt, ...props }: Props) => {
  const transformDefined = transform ?? { format: "auto" };

  return (
    <div className={className} style={style}>
      <NextImage {...props} alt={alt ?? ""} loader={createLoaderWithTransform(transformDefined)} />
    </div>
  );
};

export { LegacyImage };
